import { Logout, PersonFilled } from '@interhyp/platform-icons';
import { useTranslationContext } from '@interhyp/util-translation';
import { Button, DropdownContainer, Icon } from '@platform/elements';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import styles from './Navigation.module.scss';
import { Logo } from '../logo/Logo';

export type NavItems = { to: string; translation: string }[];

export interface NavigationProps {
  navItems: NavItems;
}

function logMeOut() {
  window.location.replace(`/authorizations/logout`);
}

export function Navigation({ navItems }: NavigationProps): JSX.Element {
  const { pathname } = useLocation();
  const { translate } = useTranslationContext();
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const ref = useRef();

  function renderNavigationItem() {
    return (
      navItems?.map(navItem => {
        return (
          <div
            className={classNames([styles.routeLink, pathname === navItem.to && styles.active])}
            key={navItem.to}
          >
            <Link to={navItem.to}>{translate(navItem.translation)}</Link>
          </div>
        );
      }) ?? <></>
    );
  }

  return (
    <div className={styles.header}>
      <div className={styles.wrapper}>
        <div className={styles.column}>
          <div className={styles.logo}>
            <Logo />
          </div>
        </div>
        <div className={styles.column}>{renderNavigationItem()}</div>
        <div className={classNames([styles.column, styles.logout])}>
          <div onClick={() => setOpenUserMenu(true)}>
            <PersonFilled ref={ref} className={styles.icon} />
          </div>
          <DropdownContainer
            visible={openUserMenu}
            appendTo="parent"
            reference={ref}
            onClickOutside={() => setOpenUserMenu(false)}
          >
            <Button variant="text" iconLeft={Logout} onClick={() => logMeOut()}>
              Abmelden
            </Button>
          </DropdownContainer>
        </div>
      </div>
    </div>
  );
}
